/**
 * INTERNAL
 * @param {Number} result 
 * @param {Object} limits 
 * @returns {Boolean} within Limits
 */
const withinLimits = (result, end, { start, dayOfWeek, dayOfMonth }) => {
    const time = new Date(result)
    if (time > end) return false
    if (time < start) return false
    if (dayOfWeek && dayOfWeek.length && !dayOfWeek.includes(time.getDay())) return false
    if (dayOfMonth && dayOfMonth.length && !dayOfMonth.includes(time.getDate())) return false
    return true
}

const withinTimes = (result, { maxHour, minHour }) => {
    const time = new Date(result)
    if (maxHour && maxHour.length && (time > new Date(time).setHours(maxHour[0], maxHour[1] || 0, 0))) return false
    if (minHour && minHour.length && (time < new Date(time).setHours(minHour[0], minHour[1] || 0, 0))) return false
    return true
}

/**
 * INTERNAL
 * @param {Number} since 
 * @param {Object} schedule 
 * @returns next valid time
 */
const calculateNextTime = (since, schedule) => {
    const result = new Date(Math.max(new Date(schedule.start || 0).getTime(), since))
    const end = new Date(Math.min(2527200000000, schedule.end || 2999999999999)).getTime()
    // eslint-disable-next-line radix
    schedule.time.sort((a, b) => parseInt(a[0] || 0) * 60 + parseInt(a[1] || 0) - parseInt(b[0] || 0) * 60 - parseInt(b[1] || 0))
    while (true) { /* eslint-disable-line no-constant-condition */
        if (result > end) throw Error('Expired')
        for (let i = 0; i < schedule.time.length; i += 1) { // We need for loop so we can break
            const hours = schedule.time[i][0] || 0
            const minutes = schedule.time[i][1] || 0
            result.setHours(hours, minutes, 0, 0)
            if (result > since && withinLimits(result, end, schedule)) {
                return result.getTime()
            }
        }
        result.setDate(result.getDate() + 1)
    }
}

/**
 * INTERNAL
 * @param {Number} since 
 * @param {Object} schedule 
 * @returns next valid interval
 */
const calculateNextInterval = (since, schedule) => {
    if (schedule.interval >= 60000) {
        let result = new Date(schedule.start || 0).getTime()
        const end = new Date(Math.min(2527200000000, schedule.end || 2999999999999)).getTime()
        // eslint-disable-next-line no-constant-condition
        while (true) {
            if (result > end) throw Error('Expired')
            if (result > since && withinLimits(result, end, schedule) && withinTimes(result, schedule)) {
                return result
            }
            result += schedule.interval
        }
    }
    else throw Error('Interval cannot be lower than one minute')
}

/**
 * WRAPPER
 * @param {Number} since starting point for the schedule
 * @param {Object} schedule object with rules for the schedule 
 * @returns {Number} nextTime the alert has to run
 */
const calculate = (schedule, since = new Date().getTime()) => {
    // eslint-disable-next-line no-prototype-builtins
    if (schedule.hasOwnProperty('isActive') && !schedule.isActive) throw Error('Inactive')
    switch (schedule.type) {
        case 'time':
            return calculateNextTime(since, schedule)
        case 'interval':
            return calculateNextInterval(since, schedule)
        default:
            throw Error('Invalid Schedule Type')
    }
}

module.exports = calculate
